module.exports = __webpack_public_path__ + "img/Barium.acd1f1d1.png";